export default __webpack_public_path__ + "static/media/legends-image.80855dfc.jpg";